import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { CurriculumOverview } from '../components/CurriculumOverview';
import { CourseGrid } from '../components/CourseGrid';
import { SpeakersSection } from '../components/SpeakersSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { CurriculumPopup } from '../components/CurriculumPopup';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780]" data-id="element-530">
      <Navbar data-id="element-531" />
      <main data-id="element-532">
        <HeroSection data-id="element-533" />
        <AboutSection data-id="element-534" />
        <CurriculumOverview data-id="element-535" />
        <CourseGrid data-id="element-536" />
        <SpeakersSection data-id="element-537" />
        <TestimonialsSection data-id="element-538" />
        <CTASection data-id="element-539" />
      </main>
      <Footer data-id="element-540" />
      <CookieBanner data-id="element-541" />
      <CurriculumPopup data-id="element-542" />
    </div>;
}